import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Tabs from '../../components/ui/Tabs';
import { funcionariosApi, beneficiosApi } from '../../api/rh';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

import DadosPessoaisTab from './tabs/DadosPessoaisTab';
import DadosTrabalhoTab from './tabs/DadosTrabalhoTab';
import BeneficiosTab from './tabs/BeneficiosTab';
import DependentesTab from './tabs/DependentesTab';
import BancarioUniformesTab from './tabs/BancarioUniformesTab';
import DocumentosTab from './tabs/DocumentosTab';
import AcessoTab from './tabs/AcessoTab';

const ABAS = [
  { chave: 'pessoais', titulo: 'Dados Pessoais' },
  { chave: 'trabalho', titulo: 'Dados do Trabalho' },
  { chave: 'beneficios', titulo: 'Vale Transporte/Alimentação' },
  { chave: 'dependentes', titulo: 'Dependentes' },
  { chave: 'bancario', titulo: 'Bancário/Uniformes' },
  { chave: 'documentos', titulo: 'Documentos' },
  { chave: 'acesso', titulo: 'Acesso e Permissões' }
];

const FORM_VAZIO = { status: 'ativo', tipo_pagamento: 'pix', dias_semana: '1,2,3,4,5' };
const BENEFICIOS_VAZIO = { vale_transporte: 0, vale_alimentacao: 0 };

export default function FuncionarioForm({ funcionarioId, onVoltar, onSalvo }) {
  const [abaAtiva, setAbaAtiva] = useState('pessoais');
  const [form, setForm] = useState(FORM_VAZIO);
  const [dependentes, setDependentes] = useState([]);
  const [beneficios, setBeneficios] = useState(BENEFICIOS_VAZIO);
  const [idAtual, setIdAtual] = useState(funcionarioId || null);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (!funcionarioId) return;
    funcionariosApi.obter(funcionarioId).then(setForm).catch(() => {});
    funcionariosApi.obterFilhos(funcionarioId).then(setDependentes).catch(() => {});
    beneficiosApi.obter(funcionarioId).then(setBeneficios).catch(() => {});
  }, [funcionarioId]);

  useTituloPagina(idAtual ? `Funcionário - ${form.nome || ''}` : 'Novo Funcionário');

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));
  const onChangeBeneficios = (campo, valor) => setBeneficios(b => ({ ...b, [campo]: valor }));

  const salvar = async () => {
    if (!form.nome) { setErro('Nome é obrigatório'); setAbaAtiva('pessoais'); return; }
    setSalvando(true);
    setErro('');
    try {
      let id = idAtual;
      if (id) {
        await funcionariosApi.atualizar(id, form);
      } else {
        const resultado = await funcionariosApi.criar(form);
        id = resultado.id;
        setIdAtual(id);
      }
      await funcionariosApi.salvarFilhos(id, dependentes);
      await beneficiosApi.salvar(id, beneficios);
      if (onSalvo) onSalvo();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  const acaoTabs = (
    <>
      <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
      <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
    </>
  );

  return (
    <div>
      <Card>
        {erro && <p style={{ color: COLORS.danger, fontSize: 13, marginTop: 0 }}>{erro}</p>}
        <Tabs abas={ABAS} ativa={abaAtiva} onMudar={setAbaAtiva} acao={acaoTabs} />

        {abaAtiva === 'pessoais' && <DadosPessoaisTab form={form} onChange={onChange} />}
        {abaAtiva === 'trabalho' && <DadosTrabalhoTab form={form} onChange={onChange} />}
        {abaAtiva === 'beneficios' && <BeneficiosTab dados={beneficios} onChange={onChangeBeneficios} />}
        {abaAtiva === 'dependentes' && <DependentesTab itens={dependentes} onChange={setDependentes} />}
        {abaAtiva === 'bancario' && <BancarioUniformesTab form={form} onChange={onChange} />}
        {abaAtiva === 'documentos' && <DocumentosTab funcionarioId={idAtual} />}
        {abaAtiva === 'acesso' && <AcessoTab funcionarioId={idAtual} nomeSugerido={form.nome} />}
      </Card>
    </div>
  );
}
